<template>
  <div id="app">
    <transition name="fadeInDown" appear>
      <Topbar />
    </transition>
    <transition name="slideInLeft">
      <Menu v-show="menuOpened" />
    </transition>
    <main>
      <!-- <transition :name="transitionName"> -->
      <router-view />
      <!-- </transition> -->
    </main>
    <PageIndicator v-if="showIndicator" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import Topbar from '@/components/Topbar.vue';
import Menu from '@/components/Menu.vue';
import PageIndicator from '@/components/PageIndicator.vue';

export default {
  components: {
    Topbar,
    Menu,
    PageIndicator,
  },
  data() {
    return {
      indicator: null,
      transitionName: '',
    };
  },
  computed: {
    ...mapGetters(['showIndicator', 'menuOpened', 'menuClicked']),
  },
  watch: {
    $route(to, from) {
      if (!to.meta.pageIndex || !from.meta.pageIndex || this.menuClicked) {
        this.transitionName = '';
        return;
      }
      if (to.meta.pageIndex > from.meta.pageIndex) {
        this.transitionName = 'slide-out';
      } else {
        this.transitionName = 'slide-in';
      }
    },
  },
};
</script>

<style lang="scss">
.slideInLeft-enter-active {
  animation: slideInLeft 0.5s;
}
.slideInLeft-leave-active {
  animation: slideInLeft 0.5s reverse;
}
.fadeInDown-enter-active {
  animation: fadeInDown 0.5s;
}
.fadeInDown-leave-active {
  animation: fadeInDown 0.5s reverse;
}
.slide-in-enter-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-in-enter {
  transform: translateY(-100%);
}
.slide-in-enter-to {
  transform: translateY(0);
}
.slide-in-leave {
  z-index: -10;
}
.slide-in-leave-active {
  transition: all 0.3s;
}
.slide-in-leave-to {
  z-index: -10;
}
.slide-out-leave {
  z-index: 10;
}
.slide-out-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-out-leave-to {
  z-index: 10;
  transform: translateY(-100%);
}
.slide-out-enter {
  z-index: -10;
}
.slide-out-enter-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-out-enter-to {
  z-index: -10;
}
</style>
